module.exports = __webpack_public_path__ + "img/active1.abb6d56d.png";